// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
// import cssVars from 'css-vars-ponyfill'
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueMask from "v-mask";
import VuejsDialog from "vuejs-dialog";

import App from "./App";
import router from "./router";
import store from "./store/store";

import VueSelect from "vue-cool-select";
Vue.use(VueSelect, {
  theme: "bootstrap" // "bootstrap" or 'material-design'
});
import Vuelidate from "vuelidate";
// todo
// cssVars()

// Register a global custom directive called v-focus
Vue.directive("focus", {
  // When the bound element is inserted into the DOM...
  inserted: function(el) {
    // Focus the element
    el.focus();
  }
});

Vue.use(BootstrapVue);
Vue.use(VueMask);
Vue.use(VuejsDialog);
Vue.use(Vuelidate);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
});
